<template>
  <div class="style-fullWidth">
    <el-form-item class="">
      <div class="jobInfoAttachment">
        <div
          v-for="vbAttachment in vbAttachments"
          v-bind:key="vbAttachment.id"
          class="file-uploaded input-none__border"
        >
          <div class="file clickable flex-row flex__between padding-0">
            <a
              class="flex-row flex__left margin-left-10"
              @click="downloadFile(vbAttachment)"
            >
              <file-type-image
                :fileExtention="vbAttachment.fileExtention"
                :customClass="''"
              />
              <span class="">{{ vbAttachment.fileName }}</span>
            </a>
            <i
              v-if="isAbleToUpdate"
              class="el-icon-circle-close margin-left-10 margin-right-10 font-size__large color__red"
              @click="removeAttachment(vbAttachment)"
            ></i>
          </div>
        </div>
      </div>
    </el-form-item>
    <el-form-item :label="fieldTitle" class="padding-bottom-10">
      <el-upload
        v-if="isAbleToUpdate"
        class="upload-demo style-fullWidth inputLog"
        drag
        :action="uploadAttachmentURL"
        size="medium"
        :on-success="
          response =>
            onUploadSuccess(response).then(response =>
              uploadAttachmentSuccess(response)
            )
        "
        :data="uploadAttachmentAdditionalData()"
        :show-file-list="false"
        :headers="uploadAttachmentHeaders"
        :before-upload="
          file => validateUploadFile(file, { acceptFileTypes: ['*'] })
        "
        :on-error="onUploadError"
        v-loading="isUploading"
      >
        <div class="el-upload__text mb-10">
          <p class="margin-0 padding-0">Tải tệp đính kèm</p>
          <img
            class="icon-small"
            src="@/assets/img/new-symbol/upload-cloud.svg"
            alt
          />
        </div>
      </el-upload>
    </el-form-item>
  </div>
</template>

<script>
import FileTypeImage from "./FileTypeImage";
import uploadFileMixin from "../doc-in/uploadFileMixin";
import handleRequestErrorMixin from "../handleRequestErrorMixin";
import constants from "../../constants";
import downloadService from "../../services/downloadService";
import h from "../../services/h";
import attachmentService from "../../services/attachmentService";
import utils from "../../services/utils";
import errorMessageFilter from "../../filters/errorMessageFilter";

export default {
  name: "task-attachments",
  mixins: [uploadFileMixin, handleRequestErrorMixin],
  components: { FileTypeImage },
  props: ["tkTaskId", "isAbleToUpdate", "fieldTitle"],

  data() {
    return {
      vbAttachments: []
    };
  },

  watch: {
    tkTaskId() {
      this.reloadPage();
    }
  },

  created() {
    this.reloadPage();
  },

  methods: {
    setVbAttachments(vbAttachments) {
      this.vbAttachments = vbAttachments;
    },

    reloadPage() {
      if (this.tkTaskId) this.loadVbAttachments();
    },

    loadVbAttachments() {
      return attachmentService
        .findAllByTask(this.tkTaskId)
        .then(response => (this.vbAttachments = response.data));
    },

    getData() {
      return h.collect(this.vbAttachments, item => item.id);
    },

    downloadFile(vbAttachment) {
      switch (vbAttachment.oldObjectType) {
        case constants.ATTACHMENT_OBJECT_TYPE.VB_DI:
          return downloadService.downloadReferenceOutgoingDoc(
            vbAttachment.oldObjectId
          );
        case constants.ATTACHMENT_OBJECT_TYPE.VB_DEN:
          return downloadService.downloadFileIncomingDoc(vbAttachment.oldObjectId);
        case constants.ATTACHMENT_OBJECT_TYPE.RELATION_DOC:
          return downloadService.downloadRelationDoc(vbAttachment.oldObjectId)
        default:
          return downloadService.downloadFileForTaskAttachment(
            this.tkTaskId,
            vbAttachment.id
          );
      }
    },

    removeAttachment(vbAttachment) {
      return (this.tkTaskId
        ? utils.confirm(
            this.$confirm,
            errorMessageFilter({ errorCode: "vbAttachment.delete.confirm" })
          )
        : Promise.resolve()
      ).then(() => {
        if(vbAttachment.oldObjectType !== undefined && vbAttachment.oldObjectType !== null) {
            const newAttachments = this.vbAttachments.filter(
              item => item.id !== vbAttachment.id
            );
            this.vbAttachments = newAttachments;
        }else {
          attachmentService
            .delete(vbAttachment.id)
            .then(() => {
              this.$message({
                type: "success",
                message: "Xóa file thành công"
              });
              this.vbAttachments.splice(
                this.vbAttachments.indexOf(vbAttachment),
                1
              );
            })
            .catch(error => {
              this.commonHandleRequestError(error);
              throw error;
            });
        }
      });
    },

    uploadAttachmentSuccess(vbAttachment) {
      this.vbAttachments.push(vbAttachment);
    },

    uploadAttachmentAdditionalData() {
      return {
        objectId: this.tkTaskId || "",
        objectType: constants.ATTACHMENT_OBJECT_TYPE.TASK,
        note: ""
      };
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/job/task-attachments.vue